import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { hasAttendees } from 'owa-calendar-event-capabilities';
import {
    getTimeSuggestionsRequestState,
    TimeSuggestions,
    TimeSuggestionsProps,
} from 'owa-calendar-time-suggestions';

export interface TimeSuggestionsHostProps extends TimeSuggestionsProps {
    className: string;
}

const TimeSuggestionsHost: React.SFC<TimeSuggestionsHostProps> = observer(props => {
    const {
        className,
        colorScheme,
        event,
        maxCandidates,
        onTimeSuggestionClicked,
        onTimeSuggestionNotFound,
        hideSchedulingAssistantLink,
    } = props;

    if (
        !hasAttendees(props.event, true /* ignoreResources */) ||
        !getTimeSuggestionsRequestState()
    ) {
        // If we don't have attendees or if time suggestions not initialized, then don't show suggestions
        return null;
    }

    return (
        <div className={className}>
            <TimeSuggestions
                colorScheme={colorScheme}
                event={event}
                maxCandidates={maxCandidates}
                hideSchedulingAssistantLink={hideSchedulingAssistantLink}
                onTimeSuggestionClicked={onTimeSuggestionClicked}
                onTimeSuggestionNotFound={onTimeSuggestionNotFound}
            />
        </div>
    );
});

export default TimeSuggestionsHost;
